module.exports = __webpack_public_path__ + "static/media/7_James_R@3x.2d67b913.jpg";